module.exports = __webpack_public_path__ + "img/badge_dispatch_master.833f4a40.png";